/**
 * Document Taxonomy Configuration
 * 
 * This file contains the configurable taxonomy for document categories.
 * Categories can be easily modified by editing this file directly.
 * 
 * Structure:
 * - id: Unique identifier for the category
 * - name: Display name for the category
 * - icon: Emoji icon for visual representation
 * - description: Detailed description for AI processing and user understanding
 */

export const DOCUMENT_TAXONOMY = {
  categories: [
    {
      id: "uncategorized",
      name: "Uncategorized Documents",
      icon: "❓",
      description: "Documents that have not yet been categorized by AI or manually assigned"
    },
    {
      id: "travel",
      name: "Travel Documents",
      icon: "✈️",
      description: "Flights, trains, car rentals, bus tickets, transportation confirmations"
    },
    {
      id: "accommodation",
      name: "Accommodation Documents",
      icon: "🏨",
      description: "Hotel bookings, rental confirmations, accommodation reservations"
    },
    {
      id: "location",
      name: "Location Documents",
      icon: "📍",
      description: "Maps, guides, attraction tickets, museum passes, location information"
    },
    {
      id: "planning",
      name: "Planning Documents",
      icon: "📋",
      description: "Itineraries, insurance, confirmations, notes, travel planning documents"
    }
  ]
};

/**
 * Get category by ID
 * @param {string} categoryId - The category ID to find
 * @returns {Object|null} The category object or null if not found
 */
export const getCategoryById = (categoryId) => {
  return DOCUMENT_TAXONOMY.categories.find(cat => cat.id === categoryId) || null;
};

/**
 * Get all category IDs
 * @returns {Array} Array of category IDs
 */
export const getCategoryIds = () => {
  return DOCUMENT_TAXONOMY.categories.map(cat => cat.id);
};

/**
 * Get categories for AI processing
 * @returns {Array} Array of categories formatted for AI prompts
 */
export const getCategoriesForAI = () => {
  return DOCUMENT_TAXONOMY.categories.map(cat => ({
    id: cat.id,
    name: cat.name,
    description: cat.description
  }));
}; 